"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var idm_dynamic_layout_interpreter_1 = require("@synisys/idm-dynamic-layout-interpreter");
var designer_content_layout_model_1 = require("./designer-content-layout.model");
var DesignerLayoutModel = /** @class */ (function () {
    function DesignerLayoutModel(content) {
        this.isSubForm = false;
        this.formEntityType = idm_dynamic_layout_interpreter_1.FormEntityType.MAIN_FORM;
        this.content = content ? content : new designer_content_layout_model_1.DesignerContentLayoutModel();
    }
    DesignerLayoutModel.prototype.setTabularContent = function (tabs) {
        this.content = new designer_content_layout_model_1.DesignerContentLayoutModel(tabs);
    };
    DesignerLayoutModel.prototype.setNonTabularContent = function (content) {
        this.content = content;
    };
    return DesignerLayoutModel;
}());
exports.DesignerLayoutModel = DesignerLayoutModel;
//# sourceMappingURL=designer-layout.model.js.map